/** Resolve course offering + fee row for Placement (Application form step 1). */

export const buildStateFeeOptions = (offering) =>
  offering?.onshoreFees?.map((item) => ({
    label: item?.state,
    value: item?.state,
    feePerSem: item?.feePerSem,
    scholarship: item?.scholarship,
    totalFees: item?.totalFees,
    discount: item?.discount,
    feeAfterScholarship: item?.feeAfterScholarship,
  })) || [];

export const buildIntakeOptions = (offering) =>
  offering?.intakes?.map((item) => ({
    label: item,
    value: item,
  })) || [];

export const resolvePlacementSelection = (courseList, { course, university, state, fee } = {}) => {
  const selectedCourse = courseList?.find((c) => c.courseId === course) ?? null;
  const offering =
    selectedCourse?.offerings?.find((o) => Number(o.universityId) === Number(university)) ?? null;

  if (!offering) {
    return { selectedCourse, selectedUniversity: null, stateFeeOptions: [], intakeOptions: [] };
  }

  const stateFeeOptions = buildStateFeeOptions(offering);
  const onshoreRow = state
    ? offering.onshoreFees?.find((f) => f?.state === state)
    : offering.onshoreFees?.[0];

  const feeFields = onshoreRow
    ? {
        feePerSem: onshoreRow.feePerSem ?? fee ?? offering.feePerSem ?? "",
        scholarship: onshoreRow.scholarship ?? offering.scholarship ?? "",
        totalFees: onshoreRow.totalFees ?? offering.totalFees ?? "",
        discount: onshoreRow.discount ?? offering.discount ?? "",
        feeAfterScholarship: onshoreRow.feeAfterScholarship ?? offering.feeAfterScholarship ?? "",
      }
    : {
        feePerSem: fee ?? offering.feePerSem ?? "",
        scholarship: offering.scholarship ?? "",
        totalFees: offering.totalFees ?? "",
        discount: offering.discount ?? "",
        feeAfterScholarship: offering.feeAfterScholarship ?? "",
      };

  return {
    selectedCourse,
    selectedUniversity: { ...offering, ...feeFields },
    stateFeeOptions,
    intakeOptions: buildIntakeOptions(offering),
  };
};

export const offeringNeedsPlacementEnrichment = (selectedUniversity) =>
  Boolean(
    selectedUniversity &&
      !Array.isArray(selectedUniversity.onshoreFees) &&
      !Array.isArray(selectedUniversity.intakes)
  );
